module.exports = __webpack_public_path__ + "img/portraits_16_V.9712d299.webp";